import React, { useEffect, useState } from "react"

import { CustomStats } from "components/page-components/Internal-Search/search-components"
import { MagnifyingGlassIcon } from "components/page-components/Icons/small"
import { connectSearchBox } from "react-instantsearch-dom"

export const InternalSearchbox = connectSearchBox(
  ({ currentRefinement, refine }) => {
    const [input_value, set_input_value] = useState("")
    const [debounced, set_debounce] = useState(null)

    const update_search_query = (e) => {
      const value = e.target.value
      set_input_value(value)
      clearTimeout(debounced)
      set_debounce(setTimeout(() => refine(e.target.value), 140))
    }

    const clear_search_input = () => {
      set_input_value("")
      refine("")
    }
    const focus_input = (input) => input && input.focus()

    useEffect(() => {
      if (!currentRefinement) {
        set_input_value("")
      }
    }, [currentRefinement])

    useEffect(() => {
      if (sessionStorage.getItem("internal_search_session_storage")) {
        const { last_search_state } = JSON.parse(
          sessionStorage.getItem("internal_search_session_storage")
        )
        if (last_search_state?.query) {
          set_input_value(last_search_state?.query)
        }
      }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    return (
      <React.Fragment>
        <div className="control has-icons-right has-icons-left pb-5-desktop">
          <input
            ref={focus_input}
            id="search"
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="none"
            spellCheck="false"
            style={{
              backgroundColor: "transparent",
              borderColor: "white",
              caretColor: "white",
            }}
            value={input_value}
            onChange={update_search_query}
            aria-label="searchbar"
            className="internal-search-box input is-medium has-text-white"
          />
          <span className="icon is-left has-text-white">
            <MagnifyingGlassIcon {...{ color: "#FFFFFF" }} />
          </span>
          <span className="icon is-right pr-3" style={{ width: "auto" }}>
            <div className="is-hidden-mobile">
              <CustomStats />
            </div>

            <button
              style={{ backgroundColor: "#979797" }}
              aria-label="clear search input"
              className={`delete ${!currentRefinement ? "is-hidden" : ""}`}
              onClick={clear_search_input}
            ></button>
          </span>
        </div>
        <div className="has-text-right py-4 is-hidden-desktop">
          <CustomStats />
        </div>
      </React.Fragment>
    )
  }
)
